/**
 * 将秒数格式化为计时器字符串（HH:mm:ss），小时可大于24。
 * @param totalSeconds 总秒数
 * @returns 格式化字符串，例如 "01:05", "12:30:45", "100:00:00"
 */
export function formatSecondsToTimer(totalSeconds: number): string {
    const floorSeconds = Math.round(totalSeconds)
    const hours = Math.floor(floorSeconds / 3600)
    const minutes = Math.floor((floorSeconds % 3600) / 60)
    const seconds = floorSeconds % 60

    const parts = [String(hours).padStart(2, '0'), String(minutes).padStart(2, '0'), String(seconds).padStart(2, '0')]

    return parts.join(':')
}
